import React from 'react';
import CustomImage from '../../components/custom-image';

const WellInvested = () => {
  return (
    <div className="accordion-body">
      <div className="content">
        <div className="two-columns">
          <div className="left-text">
            <p>
              A significant proportion of our capital investment programme has been completed, and we are now ramping up
              production to take advantage of our expanded capacity. We have already started seeing the results of our
              investments, with Zinc India and Aluminium delivering robust production in the past year, and we expect
              our Zinc International, particularly the Gamsberg project, to provide further impetus to our Zinc
              business, going forward. In the Oil & Gas business, we have begun to implement our growth projects with a
              gross capex of over US$3.2 billion, and this will enable us to increase volumes in the near and medium
              term. These increases in production will lead to strong cash flow generation through the cycle.
            </p>
          </div>
          <div className="right-image">
            <CustomImage
              className="custom-image"
              imageName="investment-grouth-capex.png"
              alt="Consolidated Group Results Bar Chart"
              maxWidth="768"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WellInvested;
